import { render, staticRenderFns } from "./PieChartComparison.vue?vue&type=template&id=76bca5a8&scoped=true&"
import script from "./PieChartComparison.vue?vue&type=script&lang=js&"
export * from "./PieChartComparison.vue?vue&type=script&lang=js&"
import style0 from "./PieChartComparison.vue?vue&type=style&index=0&id=76bca5a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bca5a8",
  null
  
)

export default component.exports